export const menuItemStyles = {
    paddingTop: 16,
    paddingBottom: 16,
};
